export function AccessDenied() {
  return (
    <main className="access-denied">
      <h1>Access denied</h1>
      <p>
        The server owner has not granted this character access. If you believe
        this is a mistake, ask the server owner to add your character to the
        whitelist or to widen the allowed corporation or alliance.
      </p>
      <p>
        <a className="access-denied__action" href="/api/auth/login">
          Sign in with a different character
        </a>
      </p>
    </main>
  );
}
